import { types } from 'mobx-state-tree';
export const ManagementPage = types.model('ManagementPage', {
  invitationModal: types.model({
    visible: types.boolean,
    inviteByPhone: true,
    invitationSent: false
  }).actions(self => ({
    setVisible(visible: boolean) {
      self.visible = visible;
    },
    setInvitationSent(successful: boolean) {
      self.invitationSent = successful;
    },
    toggleMethod() {
      self.inviteByPhone = !self.inviteByPhone;
    }
  })),
  followRequestTabPage: 1,
  followersRequestTabPage: 1,
  fieldModal: types.model({
    visible: false,
    dragging: false,
    brush: true,
    selectAll: true
  }).actions(self => ({
    setVisible(isVisible: boolean) {
      self.visible = isVisible;
    },
    setDragging(dragging: boolean) {
      self.dragging = dragging;
    },
    toggleBrush() {
      self.brush = !self.brush;
    },
    setBrush(isBrush: boolean) {
      self.brush = isBrush;
    },
    setSelectAll(isSelectAll: boolean) {
      self.selectAll = isSelectAll;
    }
  })).views(self => ({
    get isDragging() {
      return self.dragging;
    },
    get isBrush() {
      return self.brush;
    }
  })),
  optionModalVisible: false
}).actions(self => ({
  incrementFollowRequestPage() {
    self.followRequestTabPage += 1;
  },
  incrementFollowersRequestPage() {
    self.followersRequestTabPage += 1;
  },
  resetPageCount() {
    self.followRequestTabPage = 1;
    self.followersRequestTabPage = 1;
  },
  setOptionModalVisible(isVisible: boolean) {
    self.optionModalVisible = isVisible;
  }
}));